import apiSettings from "./apiSettings";
import deepCopy from "./deepCopy";

const changeQueryArgs = (hash) => {
  let query_args = deepCopy(apiSettings.defaultPayloadParams.query_args);

  if (hash.includes("page")) {
    query_args = { ...query_args, paged: new URLSearchParams(hash.replace("#", "")).get("page") };
  }

  if (hash.includes("order")) {
    const params = new URLSearchParams(hash);
    const order = params.get("order");
    const orderby = params.get("orderby");
    const meta_key = params.get("meta_key");

    if (orderby === "meta_value") {
      query_args = {
        ...query_args, order, orderby, meta_key,
      };
    } else {
      query_args = {
        ...query_args, order, orderby,
      };
    }
  }

  return query_args;
};

export default function decodeHash(hash) {
  let facets = deepCopy(apiSettings.defaultPayloadParams.facets);
  let query_args = changeQueryArgs(hash);
  const query = hash.replace("#?", "");
  if (!query) return apiSettings.defaultPayloadParams;
  query.split("&").forEach((item) => {
    const [cat, val] = item.split("=");
    facets[cat]?.push(val);
  });

  return { data: { facets, query_args } };
}
